import {Injectable} from '@nestjs/common';
import { SaleorderType } from '../sale-order-type.entity';
import { SaleorderTypeDTO } from './sale-order-type.dto';

@Injectable()
export class SaleorderTypeAdapter {
    /**
     * 
     * @param SaleorderTypeDTO 
     * @param isUpdate 
     * @returns 
     */

    public convertDtoToEntity( saleorderTypeDTO: SaleorderTypeDTO, isUpdate: boolean = false): SaleorderType {
        const saleorderType = new SaleorderType();
        saleorderType.saleorderTypeId=saleorderTypeDTO.saleorderTypeId;
        saleorderType.saleorderType=saleorderTypeDTO.saleOrderTypeName;
        saleorderType.status=saleorderTypeDTO.isActive==undefined?true:saleorderTypeDTO.isActive;
        if (isUpdate){
            saleorderType.updatedUser = saleorderTypeDTO.updatedUser;
        }else {
            saleorderType.status = true;
            saleorderType.createdUser=saleorderTypeDTO.createdUser;
        }
        return saleorderType;
    }
    public convertEntityToDto( saleorderTypeData: SaleorderType): SaleorderTypeDTO{
        const saleorderType = new SaleorderTypeDTO();
        saleorderType.saleorderTypeId=saleorderTypeData.saleorderTypeId;
        saleorderType.saleOrderTypeName=saleorderTypeData.saleorderType;
        saleorderType.isActive=saleorderTypeData.status;
        saleorderType.createdAt=saleorderTypeData.createdAt;
        saleorderType.createdUser=saleorderTypeData.createdUser;
        saleorderType.updatedAt=saleorderTypeData.updatedAt;
        saleorderType.updatedUser=saleorderTypeData.updatedUser;
        saleorderType.versionFlag=saleorderTypeData.versionFlag;
        return saleorderType;
    }
}